import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {first} from 'rxjs/operators';
import {Store} from '@ngxs/store';
import {PlayerState} from '../../../../store/player.state';

@Component({
  selector: 'gg-popup-btn',
  templateUrl: './popup.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PopupComponent implements OnInit {

  constructor(private store: Store) {
  }

  ngOnInit() {
  }

  async openPopup() {
    const src = await this.store.select(state => state.player.src).pipe(first()).toPromise();
    window.open('https://goodgame.ru/player?' + src);
  }
}
